import { useHistory } from "react-router";
import type { IconProp } from "@fortawesome/fontawesome-svg-core";
import { faChevronRight } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  AirPFExerciseSelectors,
  useCheckoutStateSelector as useSelector,
} from "@hopper-b2b/checkout";
import {
  EntryButtonEnum,
  PreviousFlightEnum,
  PriceFreezeEntryEnum,
  type PriceFreezeHistoryState,
} from "@hopper-b2b/fintech";
import { useI18nContext } from "@hopper-b2b/i18n";
import { ButtonWrap } from "@hopper-b2b/ui";

import BlueLock from "../../../../../../assets/client/blue-lock.svg";
import "./styles.scss";

export const PriceFreezeSummaryRow = () => {
  const { t, formatFiatCurrency } = useI18nContext();
  const history = useHistory();
  const priceFreezeOffer = useSelector(
    AirPFExerciseSelectors.getCheapestPriceFreezeOfferData
  );
  const pfPurchaseRedirect = useSelector(
    AirPFExerciseSelectors.getPriceFreezeRedirectUrl
  );

  if (!priceFreezeOffer) return null;

  const perPaxFiatPrice = priceFreezeOffer.price.fiat;

  const onClick = () => {
    history.push(pfPurchaseRedirect, {
      priceFreezeEntry: PriceFreezeEntryEnum.CHECKOUT_REVIEW,
      entryButton: EntryButtonEnum.HOLD_PRICE,
      previousFlight: PreviousFlightEnum.CHOSEN_FLIGHT,
    } as PriceFreezeHistoryState);
  };

  return (
    <ButtonWrap
      className="price-freeze-summary-row-container"
      onClick={onClick}
    >
      <div className="price-freeze-summary-divider" />
      <div className="price-freeze-summary-row">
        <div className="price-freeze-summary-left-content">
          <img
            src={BlueLock}
            className="price-freeze-icon"
            alt={t("priceFreezeIconAlt")}
          />
          <div className="price-freeze-description-container">
            <p className="price-freeze-summary-title">
              {t("reviewItinerary.priceFreezeDescriptionTitle", {
                price: formatFiatCurrency(perPaxFiatPrice, {
                  minimumFractionDigits: 0,
                  maximumFractionDigits: 0,
                }),
              })}
            </p>
            <p className="price-freeze-summary-subtitle">
              {t("reviewItinerary.priceFreezeDescriptionSubtitle")}
            </p>
          </div>
        </div>
        <FontAwesomeIcon
          className="mobile-right-chevron"
          icon={faChevronRight as IconProp}
        />
      </div>
    </ButtonWrap>
  );
};
